<script>
  import { onMount } from 'svelte';
  import ProductBundleItem from './ProductBundleItem.svelte';

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  /*                */
  let {
    recommendations,
    featureIndex,
    widgetTracking,
    widgetAdditionalClickTracking,
    toggleCheck,
    featuresState = {}
  } = $props();

  onMount(async () => {
    o_global.eventQBus.on('ft6bcn.reco-aos-frontend.a2b-banner-close', () => {});
  });
</script>

<div class="reco_aos_product_card_list oc-pt-0">
  {#each recommendations as recommendation}
    <!--   TODO define behaviour on error {add2basketErrorCallback} -->
    <ProductBundleItem
      {recommendation}
      {featureIndex}
      {widgetTracking}
      {widgetAdditionalClickTracking}
      {toggleCheck}
      {featuresState} />
  {/each}
</div>

<style lang="scss">
  .reco_aos_product_card_list {
    border-bottom: 1px solid var(--oc-semantic-color-disabled-background);
    padding-bottom: 4px;
  }
</style>
